module.exports = __webpack_public_path__ + "img/heart.8858977e.svg";